export default {"src":"/_next/static/media/mobile_consultunt_img_02.273c4bb9.svg","height":140,"width":300};